export default "__VITE_ASSET__e48f3c70__"